<template>
  <div class="login-wrap">
    <div class="logo-wrap">
      <div class="flex flex-row-start" @click="goIndex">
        <img src="@/static/images/top-logo.png" alt="">
      </div>
    </div>
    <div class="flex flex-row-center form-wrap" :style="{'backgroundImage': 'url('+bg+')'}">
      <div class="form-box">
        <div class="form-title">注册</div>
        <el-form :model="formData" :rules="rules" label-position="top" ref="loginFormRef">

          <el-form-item label="" prop="username">
            <el-input v-model="formData.username" placeholder="手机号码" name="username"></el-input>
          </el-form-item>

          <el-form-item label="" prop="imageCaptcha" class="code-item">
            <div class="flex flex-row-between">
              <el-input v-model="formData.imageCaptcha" placeholder="图像验证码"></el-input>
              <el-image :src="imageCode" @click="getCaptchaImgHandle"></el-image>
            </div>
          </el-form-item>

          <el-form-item label="" prop="password">
            <el-input type="password" v-model="formData.password" placeholder="密码，6~20位（需包含字母和数字）"></el-input>
          </el-form-item>

          <el-form-item label="" prop="confirmPassword">
            <el-input type="password" v-model="formData.confirmPassword" placeholder="重复密码"></el-input>
          </el-form-item>

          <el-form-item class="check-item" prop="agree">
            <div class="flex flex-row-start">
              <el-checkbox v-model="formData.agree" label="点击同意"></el-checkbox>
              <router-link class="link" to="/netapplication">《肥城信用网站服务协议》</router-link>
            </div>
          </el-form-item>

          <el-form-item>
            <el-button class="login-button" type="primary" @click="submitHandler">注册</el-button>
          </el-form-item>

          <div class="flex flex-row-end">
            <router-link class="register-link" to="/login">已有账户？<span>立即登录</span></router-link>
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
// 引入 AES 库
import CryptoJS from 'crypto-js';
import { register } from '@/api';
import { v4 as uuidv4 } from 'uuid';
import BASE_URL from '@/api/base.js';

// ★★★ AES 密钥 (必须是16位字符串) ★★★
// 前后端必须保持一致，复制这个字符串给后端
const AES_KEY = "xVjzymyDzUN8dk0W";

export default {
  name: 'Register',
  data() {
    // 密码校验逻辑保持不变...
    const validatePasswordComplexity = (rule, value, callback) => {
      const reg = /^(?=.*[a-zA-Z])(?=.*[0-9])[A-Za-z0-9._~!@#$^&*]{6,20}$/;
      if (!value) {
        callback(new Error('请输入密码'));
      } else if (!reg.test(value)) {
        callback(new Error('密码需包含字母和数字，长度6-20位'));
      } else {
        if (this.formData.confirmPassword) {
          this.$refs.loginFormRef.validateField('confirmPassword');
        }
        callback();
      }
    };
    const validateConfirmPassword = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.formData.password) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };

    return {
      bg: require('@/static/images/login/bg.png'),
      formData: {
        username: '',
        password: '',
        confirmPassword: '',
        imageCaptcha: '',
        imageToken: '',
        agree: false
      },
      rules: {
        username: [
          { required: true, message: '请输入手机号码', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的11位手机号码', trigger: 'blur' }
        ],
        password: [
          { required: true, validator: validatePasswordComplexity, trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, validator: validateConfirmPassword, trigger: 'blur' }
        ],
        imageCaptcha: [
          { required: true, message: '请输入图片验证码', trigger: 'blur' }
        ],
        agree: [
          { required: true, message: '请阅读并选择同意网站协议', trigger: 'change' }
        ]
      },
      imageCode: '',
      uuid: ''
    };
  },
  methods: {
    goIndex() {
      this.$router.push('/');
    },
    getCaptchaImgHandle() {
      const uuid = uuidv4();
      this.uuid = uuid;
      this.formData.imageToken = uuid;
      this.imageCode = BASE_URL + `/api/captcha/image?token=${this.uuid}`;
    },

    // ★★★ AES 加密方法 ★★★
    encryptByAES(message) {
      const key = CryptoJS.enc.Utf8.parse(AES_KEY);
      const srcs = CryptoJS.enc.Utf8.parse(message);
      const encrypted = CryptoJS.AES.encrypt(srcs, key, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
      });
      return encrypted.toString();
    },

    submitHandler() {
      this.$refs['loginFormRef'].validate((valid) => {
        if (valid) {
          const { username, imageToken, imageCaptcha, password, confirmPassword } = this.formData;

          // 1. 加密 账号 (username/mobile)
          const encryptedUsername = this.encryptByAES(username);
          // 2. 加密 密码
          const encryptedPassword = this.encryptByAES(password);
          // 3. 加密 确认密码
          const encryptedRePassword = this.encryptByAES(confirmPassword);

          console.log("加密后的账号:", encryptedUsername);

          const reqData = {
            mobile: encryptedUsername, // ★★★ 发送密文
            imageToken: imageToken,
            imageCaptcha: imageCaptcha,
            password: encryptedPassword, // 发送密文
            rePassword: encryptedRePassword // 发送密文
          };

          register(reqData).then(() => {
            this.$message.success('注册成功');
            this.$router.replace('/login');
          }).catch(err => {
            console.error(err);
            this.getCaptchaImgHandle();
          });
        }
      });
    }
  },
  mounted() {
    this.getCaptchaImgHandle();
  }
};
</script>
<style lang="scss">
@import './login.scss';

.form-box {
  height: auto !important;
  padding-bottom: 15px !important;

  .check-item {
    .el-form-item__content {
      justify-content: flex-start;
      .link {
        color: $red;
      }
    }
  }

  .el-input__inner {
    border: 1px solid #efefef !important;
    border-radius: 3px;
  }

  .code-item {
    .el-button {
      margin-left: 15px;
      height: 38px;
      background-color: $red;
      border-color: $red;
    }

    .el-image {
      width: 90px;
      height: 38px;
      margin-left: 15px;
      cursor: pointer;
      display: block;
      flex-shrink: 0;

      .el-image__inner {
        width: 90px;
      }
    }
  }

  .login-button {
    margin-top: 0 !important;
  }
}
</style>
